import { toast } from '@buffer-mono/popcorn'

export const copyToClipboard = async (
  text: string,
  {
    successMessage = 'Copied to clipboard',
    errorMessage = 'Unable to copy',
  }: { successMessage?: string; errorMessage?: string } = {},
): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text)
    toast.success(successMessage)

    return true
  } catch {
    toast.error(errorMessage)

    return false
  }
}

export const copyTokenToClipboard = async (token: string): Promise<boolean> =>
  copyToClipboard(token, {
    successMessage: 'Key copied to clipboard',
    errorMessage: 'Unable to copy key',
  })
